import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug }: CategoryNavProps) {
  return (
    <section className="py-6 bg-background-50 border-b border-background-200/70">
      <div className="container-main">
        <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
          <Link
            to="/"
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
              !activeSlug
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
            }`}
          >
            <i className="ri-home-4-line"></i>
            全部
          </Link>
          {videoCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
              }`}
            >
              <i className={cat.icon}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}